import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'System|Pages|Not Found';

type SPNotFoundLocs =
	| 'SPSystemNotFoundTitle'
	| 'SPSystemNotFoundContent'
	| 'SPSystemNotFoundButton';

type CPNotFoundLocs =
	| 'CPSystemNotFoundTitle'
	| 'CPSystemNotFoundContent'
	| 'CPSystemNotFoundButton';

export const spNotFoundLocs: LocDefs<SPNotFoundLocs> = {
	SPSystemNotFoundTitle: {
		defaultValue: 'Not Found',
		displayPath: `${dpRoot}|Title`,
		description: 'Title for the not found page.',
		displayType: 'Title',
		feature: HubFeature.Core,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPSystemNotFoundContent: {
		defaultValue: '',
		displayPath: `${dpRoot}|Content`,
		description:
			'Content displayed on the not found page. Leave blank to just display the title and button.',
		displayType: 'Content',
		feature: HubFeature.Core,
		htmlAllowed: true,
		shared: false,
		portal: 'SP',
	},
	SPSystemNotFoundButton: {
		defaultValue: 'Go Back',
		displayPath: `${dpRoot}|Button`,
		description: 'Text displayed in the go back button.',
		displayType: 'Button',
		feature: HubFeature.Core,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
};

export const cpNotFoundLocs: LocDefs<CPNotFoundLocs> = {
	CPSystemNotFoundTitle: {
		defaultValue: 'Not Found',
		displayPath: `${dpRoot}|Title`,
		description: 'Title for the not found page.',
		displayType: 'Title',
		feature: HubFeature.CandidateAccess,
		htmlAllowed: false,
		shared: false,
		portal: 'CP',
	},
	CPSystemNotFoundContent: {
		defaultValue: '',
		displayPath: `${dpRoot}|Content`,
		description:
			'Content displayed on the not found page. Leave blank to just display the title and button.',
		displayType: 'Content',
		feature: HubFeature.CandidateAccess,
		htmlAllowed: true,
		shared: false,
		portal: 'CP',
	},
	CPSystemNotFoundButton: {
		defaultValue: 'Go Back',
		displayPath: `${dpRoot}|Button`,
		description: 'Text displayed in the go back button.',
		displayType: 'Button',
		feature: HubFeature.CandidateAccess,
		htmlAllowed: false,
		shared: false,
		portal: 'CP',
	},
};

export const LOC_KEYS = MapLocKeys<SPNotFoundLocs | CPNotFoundLocs>({
	...spNotFoundLocs,
	...cpNotFoundLocs,
});
export type NotFoundLocType = LocMap<SPNotFoundLocs | CPNotFoundLocs>;
